// extracted by mini-css-extract-plugin
module.exports = {"table":"MonthlyPremiumCard_table__2EMUu"};